import {Utils} from '../underscore-extensions';
class SignUpBlock implements ng.IComponentController {
    email: string;

    constructor(private $state: ng.ui.IStateService) {

    }

    openSignUp() {
        const state = Utils.getProduct().toLowerCase();
        this.$state.go(`${state}-signup`, {email: this.email, sendRequest: true})
    }
}

angular.module('animatronApp.signUpBlock', []).component('signUpBlock', {
    controller: SignUpBlock,
    templateUrl: require('sign-up-block.html')
});



// WEBPACK FOOTER //
// ./app/assets/javascripts/directives/signUpBlock.ts